import AdminRoutes from './admin/aside.routes';

const presentation: never[] = [];

const aside = [...presentation, ...AdminRoutes];

export default aside;
